var React = require('react');

function DownSwoopArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.292894 29.7071C-0.0976315 29.3166 -0.0976315 28.6834 0.292894 28.2929L6.65685 21.9289C7.04738 21.5384 7.68054 21.5384 8.07107 21.9289C8.46159 22.3195 8.46159 22.9526 8.07107 23.3431L2.41421 29L8.07107 34.6569C8.46159 35.0474 8.46159 35.6805 8.07107 36.0711C7.68054 36.4616 7.04738 36.4616 6.65685 36.0711L0.292894 29.7071ZM25.9858 0.968288C26.1382 5.77156 25.0941 12.9774 21.4211 19.0195C17.7113 25.122 11.3319 30 1 30V28C10.5678 28 16.3296 23.5447 19.7121 17.9805C23.1313 12.356 24.1305 5.56177 23.9868 1.03171L25.9858 0.968288Z","fill":"white"}));
}

DownSwoopArrow.defaultProps = {"width":"26","height":"37","viewBox":"0 0 26 37","fill":"none"};

module.exports = DownSwoopArrow;

DownSwoopArrow.default = DownSwoopArrow;
